import React, { useEffect, useState } from 'react';
import { dataForDayOffSupervisorTable } from 'shared/helpers/utils';
import { Badge, notification } from 'antd';
import { useAppSelector } from 'app/store';
import { RequestsSearch } from 'shared/types/types';
import { RequestStatusType } from 'shared/enums';
import { SearchKeysNews } from 'shared/enums/news';
import { getCurrentDivision } from 'entities/divisions/model';
import { TabKeys } from 'features/divisions';
import { ColumnsType } from 'antd/lib/table';
import { DayOffsStatusesMap, DayOffsStatusTypesMap } from 'shared/types/dayoff.types';
import { TableDayOff } from 'features/tables/supervisor/TableDayOff';
import { getDayOffSupervisor } from 'entities/supervisor/dayOff';
import { dayoffsSupervisorApi, TPerparedDayOffSupervisor } from 'app/services/edpApiV1/supervisor/dayoffSupervisor';
import { returnErrorOrMessage } from 'shared/helpers/errors';
import style from './index.module.scss';

export type TPreparedVacationSupervisorInfoData = {
  key: number;
  id: number;
  fio: string;
  vacationType: string;
  type: string;
  startedAt: string;
  endedAt: string;
  amountDays: number;
  status: {
    name: string;
    type: RequestStatusType;
  };
};

export const VacationArchive = () => {
  const [page, setCurrentPage] = useState<number>(1);
  const [size, setCurrentSize] = useState<number>(10);
  const [search, setSearch] = useState<RequestsSearch>({ byId: undefined, fio: undefined });

  const [getDayOffsDeputy] = dayoffsSupervisorApi.useLazyDayoffsDeputyQuery();
  const [getDayOffsActing] = dayoffsSupervisorApi.useLazyDayoffsActingQuery();
  const [getDayOffsSupervisor] = dayoffsSupervisorApi.useLazyDayoffsSupervisorQuery();

  const { data, pagination, loading } = useAppSelector(getDayOffSupervisor);
  const { currentOption } = useAppSelector(getCurrentDivision);

  const refetch = () => {
    if (!currentOption) {
      return;
    }
    try {
      switch (currentOption.type) {
        case TabKeys.ACTING:
          getDayOffsActing({ isArchive: true, page, size, divisionId: currentOption.value, ...search });
          break;
        case TabKeys.DEPUTY:
          getDayOffsDeputy({ isArchive: true, page, size, divisionId: currentOption.value, ...search });
          break;
        case TabKeys.SUPERVISOR:
          getDayOffsSupervisor({ isArchive: true, page, size, ...search });
          break;
      }
    } catch (e: any) {
      notification.error({ message: returnErrorOrMessage(e, 'Что-то пошло не так') });
    }
  };

  useEffect(() => {
    refetch();
  }, [currentOption, search, page, size]);

  const columns: ColumnsType<TPerparedDayOffSupervisor> = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
      width: 100,
    },

    {
      title: 'ФИО',
      dataIndex: 'fio',
      key: 'fio',
    },
    {
      title: 'Дата начала',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Дата окончания',
      dataIndex: 'endDate',
      key: 'date',
    },

    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => (
        <span>
          <Badge className={style.badge} status={status ? DayOffsStatusTypesMap[status] : 'processing'} />
          {DayOffsStatusesMap[status]}
        </span>
      ),
    },
  ];

  const onSearch = (data: string, key: SearchKeysNews) => {
    if (key === SearchKeysNews.SEARCH_ID) {
      setSearch({ fio: undefined, byId: data ? data : undefined });
    } else if (key === SearchKeysNews.SEARCH_NAME) {
      setSearch({ byId: undefined, fio: data ? data : undefined });
    } else {
      setSearch({ [key]: data ? data : undefined });
    }
  };

  const onRowClick = (data: any) => {};

  return (
    <>
      {data && columns && (
        <TableDayOff
          dataSource={dataForDayOffSupervisorTable(data || [])}
          columns={columns}
          currentPage={page}
          setCurrentPage={setCurrentPage}
          currentSize={size}
          setCurrentSize={setCurrentSize}
          total={pagination?.total}
          onSearch={onSearch}
          onRowClick={onRowClick}
          loading={loading}
        />
      )}
    </>
  );
};
